export default {
  exports: state => state.exports,
  export: state => state.export,
  exportationFlow: state => state.exportationFlow,
  exportationFlows: state => state.exportationFlows,
  exportHistory: state => state.exportHistory,
  exportsHistory: state => state.exportsHistory,
  exportsHistoryFilters: state => state.exportsHistoryFilters,
  isCallingExports: state => state.isCallingExports
}
